import React, {useState} from "react";

//Importing Material UI stuff
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
//Importing Components
import { OutlinedButton } from "../../components/Buttons";

import style from "./style";
const useStyles = makeStyles(style);

const LinkCards = ({links}) => {
    const classes = useStyles();
    return (
        <>
            {links.map((link, id) => (
                <a href={link.link} target="_blank" rel="noreferrer">
                    <Grid data-aos="fade-in" key={id} className={`${classes.card} hover-detect`}>
                    <img className={classes.cardImg} src={link.image} alt="card image" />
                    <Grid>
                        <Typography variant="h4" className={classes.cardTitle}>{link.title}</Typography>
                        <Typography variant="h6" className={classes.cardDescription}>{link.description}</Typography>
                    </Grid>
                </Grid>
                </a>
            ))}
        </>
    );
};

export default LinkCards;
